export default {
  getNewNotification: (state) => {
    return state.notificationList.filter(notif => notif.seen_status === 0)
  },
  getNotificationList: (state) => {
    return state.notificationList
  }
}